import { MAX_WEEKLY_HOURS_SCHEDULED_PER_WORKER_MS } from '@careerstart/wae-common/schema/models/corporation/constants';
import { ONE_HOUR_IN_MS } from '@careerstart/wae-common/src/main/constants/timeConversions';

import {
  composeValidators,
  isGreaterThan,
  isInteger,
  isLessThanOrEqual,
  isRequiredFieldEmpty,
} from '../../../../../../main/components/Form/validations';

export const MAX_WEEKLY_HOURS_SCHEDULED_PER_WORKER =
  MAX_WEEKLY_HOURS_SCHEDULED_PER_WORKER_MS / ONE_HOUR_IN_MS;

export const validateMaxWeeklyHoursScheduledPerWorker = composeValidators(
  isRequiredFieldEmpty,
  isInteger,
  isGreaterThan(0),
  isLessThanOrEqual(MAX_WEEKLY_HOURS_SCHEDULED_PER_WORKER)
);
